<template>
  <div>
    <v-layout row>
      <v-flex xs5>
        <v-select
          v-if="lock"
          readonly
          :items="workOrderTypes"
          v-model="wo.type"
          @change="woChanged"
          label="WorkOrder Type"
          class="subheading font-weight-bold"
        ></v-select>
        <v-select
          v-else
          :items="workOrderTypes"
          v-model="wo.type"
          @change="woChanged"
          label="WorkOrder Type"
          class="subheading font-weight-bold"
        ></v-select>
      </v-flex>
      <v-flex xs5>
        <v-autocomplete
          single-line
          v-model="wo.Lot.lotNumber"
          :items="lotsForVintage"
          @change="lotChanged"
          item-text="lotNumber"
          item-value="lotNumber"
          label="Lot"
        >
          <template
            slot="item"
            slot-scope="data"
          >{{data.item.lotNumber}} - {{ data.item.description }}</template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs4>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field slot="activator" label="Due Date:" :value="prettyDate(wo.date)" readonly></v-text-field>
          <v-date-picker
            v-model="wo.date"
            @change="woChanged"
            no-title
            scrollable
            @input="menu = false"
          >
            <!-- <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="saveDate(wo.date)">OK</v-btn>-->
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          v-model="wo.workPerformedBy"
          :items="workers"
          @change="woChanged"
          label="Work to be Performed by"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-select
          :items="workOrderStatuses"
          label="Status"
          v-model="wo.status"
          @change="statusChanged"
        ></v-select>
      </v-flex>
    </v-layout>
    <div>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Vintage:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.vintage }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">ClientCode:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.client.CODE }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Client:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.client.CLIENTNAME }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Lot:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ wo.Lot.lotNumber }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Lot Name:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ wo.Lot.description }}</div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import myMixins from '../mixins/myMixins'
import moment from 'moment'

export default {
  props: ['wo', 'lock'], // primaryLot is the lot of the parent workorder. we need to know this to prevent unselecting that lot.
  data () {
    return {
      menu: false,
      workOrderStatuses: ['ASSIGNED', 'COMPLETED'],
      workers: [
        { text: 'PDC STAFF', value: 'CCC' },
        { text: 'CLIENT', value: 'CLIENT' }
      ],
      workOrderTypes: [
        'ADDITION',
        'BLEEDOFF',
        'BBL DOWN',
        'BLENDING',
        'BOTTLING',
        'FILTRATION',
        'HEAT TANK',
        'LAB TEST',
        'OTHER',
        'PRESSOFF',
        'PULL SAMPLE',
        'RACKING',
        'SCP',
        'SETTLING',
        'TOPPING'
      ]
    }
  },
  mixins: [myMixins],
  watch: {
    wo: {
      handler: function (nv, ov) {
        // console.log(JSON.stringify(nv, null, 2))
      },
      deep: true
    }
  },
  created () {},
  methods: {
    lotChanged () {
      this.$emit('woChanged', this.wo)
    },
    saveDate (date) {
      this.wo.date = moment(date)
        .add(5, 'hours')
        .format('YYYY-MM-DDThh:mm:ss')
      this.menu = false
    },
    statusChanged (value) {
      if (value === 'ASSIGNED') {
        this.wo.isComplete = false
      } else {
        this.wo.isComplete = true
      }
      console.log(JSON.stringify(this.wo, null, 2))
      this.$emit('woChanged', this.wo)
    },
    woChanged (value) {
      console.log(JSON.stringify(value, null, 2))
      console.log(JSON.stringify(this.wo, null, 2))
      this.$emit('woChanged', this.wo)
    }
  },
  computed: {
    lotsForVintage () {
      return this.$store.state.lotsForVintage
    }
  }
}
</script>

<style scoped>
</style>
